import { useLang } from "../contexts/LanguageContext";

export function ProducersSection() {
  const { t } = useLang();
  const items = [
    { key: "colombia", title: t.producers.colombia, desc: t.producers.colombia_desc, code: "CO" },
    { key: "peru", title: t.producers.peru, desc: t.producers.peru_desc, code: "PE" },
    { key: "ecuador", title: t.producers.ecuador, desc: t.producers.ecuador_desc, code: "EC" },
    { key: "dominican", title: t.producers.dominican, desc: t.producers.dominican_desc, code: "DO" },
  ];

  return (
    <section
      id="producers"
      data-testid="producers-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-muted/40 relative"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16">
        <div className="md:col-span-5">
          <p className="tracking-eyebrow uppercase text-xs text-secondary mb-4">
            {t.producers.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            {t.producers.title}
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            {t.producers.lead}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
        {items.map((p) => (
          <div
            key={p.key}
            data-testid={`producer-card-${p.key}`}
            className="bg-background p-8 md:p-10 space-y-6 group hover:bg-card transition-colors"
          >
            <div className="flex items-center justify-between">
              <span className="font-display text-5xl text-secondary">{p.code}</span>
              <span className="tracking-eyebrow text-[10px] uppercase text-muted-foreground">
                South America · Caribbean
              </span>
            </div>
            <h3 className="font-display text-2xl md:text-3xl">{p.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
